<div style="background-color:#7E82F2;color:whitesmoke;height:8%">
    <i class="material-icons" style="float: right;padding-top:8px;padding-right: 15px;color:white;cursor:pointer;"
        (click)="close()">close</i>
    <h4 mat-dialog-title style="text-align:center; font-size:1.25rem;padding-top:8px;">Preview of
        {{title |titlecase}}
    </h4>
</div>

<iframe width="100%" height="650px" style="overflow:hidden;padding:5px;" frameborder="0" [src]="formUrl"></iframe>